export default {
  '9a4f1f4': {
    message: 'User is admin',
  },
  SM9D5DCEF: {
    message: 'Browser Successfully Validated',
  },
  SMF84092A: {
    message: 'User Token Successfully Validated',
  },
  SM482973A: {
    message: 'No person with this login was found',
  },
  SM0ADC866: {
    message: 'A person with this login was found',
  },
  SM7AF8780: {
    message: 'A person with this pre login was found',
  },
  SME4478C3: {
    message: 'Login successfully',
  },
  SM034DABA: {
    message: 'Logout successfully',
  },
  SME47D66D: {
    message: 'Requisição recebida pelo Servidor',
  },
  SM1ECFC73: {
    message: "The 'wllttkn' was successfully validated",
  },
  SM7E4DDB4: {
    message: "The 'digital wallet account password' was successfully validated",
  },
  SM99C44BC: {
    message: "The 'Password recovery token' was successfully validated"
  },
  SMBF4E9EA: {
    message: "You have the permission needed to perform such task"
  },
  SM7094F7E: {
    message: "The 'process management' was successfully validated"
  }
};
